import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { buildHttpParams } from '../../../../core/utils/http-util';
import { endpoints } from '../../../core/constants/endpoints';
import { EnumSituacao } from '../../../shared/enums/situacao.enum';
import { IDNAFilter, IDNAListFilter } from '../interfaces/dna-filter.interface';
import { IDNAParametros } from '../interfaces/dna-parametros.interface';
import {
  IDNAListItem,
  IDNAListResponse,
  IDNAPayload,
  IDNAResponse,
} from '../interfaces/dna-request.interface';
import { IDNA } from '../interfaces/dna.interface';

@Injectable({ providedIn: 'root' })
export class DnaApi {
  private apiUrl = `${environment.pathApi}/${endpoints.product.dnas}`;

  constructor(private http: HttpClient) {}

  fetchAll(filters?: IDNAFilter): Observable<IDNAResponse> {
    const params = buildHttpParams(filters);
    return this.http.get<IDNAResponse>(this.apiUrl, { params });
  }

  list(filters?: IDNAListFilter): Observable<IDNAListItem[]> {
    const params = buildHttpParams(filters);
    return this.http
      .get<IDNAListResponse>(`${this.apiUrl}/0/list`, { params })
      .pipe(map((response) => response?.data ?? []));
  }

  fetchById(id: number): Observable<IDNA> {
    return this.http.get<IDNA>(`${this.apiUrl}/${id}`);
  }

  fetchParametros(id: number): Observable<IDNAParametros> {
    return this.http.get<IDNAParametros>(`${this.apiUrl}/${id}/parametros`);
  }

  create(payload: IDNAPayload): Observable<IDNA> {
    return this.http.post<IDNA>(this.apiUrl, payload);
  }

  update(id: number, payload: IDNAPayload): Observable<IDNA> {
    return this.http.put<IDNA>(`${this.apiUrl}/${id}`, payload);
  }

  delete(id: number): Observable<string> {
    return this.http.delete(`${this.apiUrl}/${id}`, { responseType: 'text' });
  }

  updateSituacao(id: number, situacao: EnumSituacao): Observable<string> {
    const options = { responseType: 'text' as const };
    return this.http.put(`${this.apiUrl}/${id}/situacao`, { situacao }, options);
  }

  realocarBiotipo(idDna: number, idBiotipo: number): Observable<string> {
    const options = { responseType: 'text' as const };
    return this.http.put(`${this.apiUrl}/${idDna}/biotipo`, { idBiotipo }, options);
  }
}
